import React from 'react';
import classNames from 'classnames';
import useDevice from '@/hooks/useDevice';
import PageBody from './PageBody';
import './styles.css';

export interface PageContainerProps extends React.PropsWithChildren {
  title?: string;
  endElement?: React.ReactNode;
  desktopCenterElement?: React.ReactNode;
  noPadding?: boolean;
  displayFlex?: boolean;
  hideScrollbar?: boolean;
  bodyClassName?: string;
  containerClassName?: string;
}

export function PageContainer({ containerClassName, bodyClassName, ...props }: PageContainerProps) {
  const { isDesktop } = useDevice();

  return (
    <div
      className={classNames('w-full font-sans pt-1', containerClassName)}
      style={{ height: 'calc(100% - 30px)' }}
    >
      {props.title && (
        <div
          className={`page-container-title-bar flex items-center justify-between pb-2 ${!isDesktop() ? 'px-1' : ''}`}
        >
          <div className="px-1" />
          <div className="flex items-center gap-2 me-auto">
            <div
              className={
                isDesktop()
                  ? '3xl:text-2xl font-bold mt-4 xl:mt-0 text-nowrap'
                  : 'text-white text-lg text-nowrap'
              }>
              {props.title}
            </div>
          </div>
          {isDesktop() && props.desktopCenterElement ? (
            props.desktopCenterElement
          ) : (
            <div />
          )}
          <div className="flex items-center gap-2">
            {props.endElement || <div className="px-1" />}
          </div>
        </div>
      )}
      <PageBody
        className={bodyClassName}
        noPadding={props.noPadding}
        displayFlex={props.displayFlex}
        hideScrollbar={props.hideScrollbar}>
        {props.children}
      </PageBody>
    </div>
  );
};

export default PageContainer;
